import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';
import { getDueDateUrgency, type DueDateUrgency } from '@bliks-io/contracts';
import { cn } from '@bliks-io/ui';

export const dueDateUrgencyClassName: Record<DueDateUrgency, string> = {
  normal: '',
  warning: 'text-warning',
  overdue: 'text-danger',
  critical: 'text-danger font-semibold'
};

export function DueDateCell({
  dueDate,
  standardRecordingTimeMs
}: {
  dueDate?: number;
  standardRecordingTimeMs: number;
}) {
  const { i18n } = useTranslation();
  if (!dueDate) return <span className="text-sm text-muted-foreground">—</span>;
  const urgency = getDueDateUrgency(dueDate, standardRecordingTimeMs);
  return (
    <span className={cn('text-sm', dueDateUrgencyClassName[urgency])}>
      {urgency === 'critical' && (
        <AlertTriangle className="inline-block h-3.5 w-3.5 mr-1 align-text-bottom" />
      )}
      {new Date(dueDate).toLocaleDateString(i18n.language, {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      })}
    </span>
  );
}
